import { BigNumber } from 'ethers'

export const distribution = [
  {
    account: '0x896b94f4f27f12369698C302e2049cAe86936BbB',
    amount: BigNumber.from('333333333333333000000000'),
  },
  {
    account: '0x90E1F595Abc8D731cf82031c974aDD334B84b29E',
    amount: BigNumber.from('262064235897436000000000'),
  },
  {
    account: '0x3eF7f258816F6e2868566276647e3776616CBF4d',
    amount: BigNumber.from('241025641025641000000000'),
  },
  {
    account: '0x4c46f9a3Da4F7F2911e29dae334ebCf09101a669',
    amount: BigNumber.from('205128205128205000000000'),
  },
  {
    account: '0x002A5dc50bbB8d5808e418Aeeb9F060a2Ca17346',
    amount: BigNumber.from('205128205128205000000000'),
  },
  {
    account: '0x0EB4ADD4bA497357546DA7F5D12D39587cA24606',
    amount: BigNumber.from('205128205128205000000000'),
  },
  {
    account: '0x376955C79B654e1F80733D127394d8008e953882',
    amount: BigNumber.from('205128205128205000000000'),
  },
  {
    account: '0x549C0421c69Be943A2A60e76B19b4A801682cBD3',
    amount: BigNumber.from('205128205128205000000000'),
  },
  {
    account: '0xC1fc118D52e4Bc0A257F6744c77A611ad09f7777',
    amount: BigNumber.from('192271220512821000000000'),
  },
  {
    account: '0x1ad015A04C3a21330a388f6a0995c7C092E66F93',
    amount: BigNumber.from('192047025641026000000000'),
  },
  {
    account: '0xF50F1f8635823Ac38A3f36af4478fFa8a2810424',
    amount: BigNumber.from('172966112820513000000000'),
  },
  {
    account: '0xe5D0Ef77AED07C302634dC370537126A2CD26590',
    amount: BigNumber.from('153846153846154000000000'),
  },
  {
    account: '0x66F932Ad6d530603ca9c95AAa9eD6348cBbf018E',
    amount: BigNumber.from('146725158974359000000000'),
  },
  {
    account: '0xD4F513A3A8Db3AB5cAa1a5B4c8cE812893B32760',
    amount: BigNumber.from('128563958974359000000000'),
  },
  {
    account: '0xD6E6A9d952f56E48462092bBaDaB346e95E987A4',
    amount: BigNumber.from('118501743589744000000000'),
  },
  {
    account: '0xB5fC9EEf8f391051ECfC1c7d71D617181A56539B',
    amount: BigNumber.from('112030061139487000000000'),
  },
  {
    account: '0xA4Db6e848f1C4aF89D2d4D4cC350Acbc1F5F93E3',
    amount: BigNumber.from('103492092307692000000000'),
  },
  {
    account: '0x1C051112075FeAEe33BCDBe0984C2BB0DB53CF47',
    amount: BigNumber.from('102564102564103000000000'),
  },
  {
    account: '0x28d804Bf2212E220BC2B7B6252993Db8286dF07f',
    amount: BigNumber.from('102564102564103000000000'),
  },
  {
    account: '0x14A03CA8740A0044E63d3Bb0432540d9509473d1',
    amount: BigNumber.from('97493794871794900000000'),
  },
  {
    account: '0xEde81dBF541e36F47E8Af619Efa3Fe701B606915',
    amount: BigNumber.from('89691589743589800000000'),
  },
  {
    account: '0x1FE9Fd1156688699F4ca017E72ee0D9873f9d758',
    amount: BigNumber.from('88065805128205100000000'),
  },
  {
    account: '0x0B1FDB90501286ebe6087b6660C3a48db9898FAD',
    amount: BigNumber.from('84048215384615400000000'),
  },
  {
    account: '0xa8d25C5A6f832a9423038c86529391aA7B7F91a0',
    amount: BigNumber.from('83094571762051300000000'),
  },
  {
    account: '0x648AD6f58367B42Ba3EfAb45B220528E4F180437',
    amount: BigNumber.from('76722800000000000000000'),
  },
  {
    account: '0xd30391E21741C54c32987bCfcA3D880E6D261Cb0',
    amount: BigNumber.from('73100646677948700000000'),
  },
  {
    account: '0x750c31d2290c456FcCA1c659b6AdD80e7A88f881',
    amount: BigNumber.from('66394871794871800000000'),
  },
  {
    account: '0x7B6d03eda08626BbfF1aBdf1340B999670e1fc28',
    amount: BigNumber.from('65878748717948700000000'),
  },
  {
    account: '0xe65964de92D2d2540e73388B1037c964674D572b',
    amount: BigNumber.from('63383917948718000000000'),
  },
  {
    account: '0x6eF3f0fF397C3de367C6cA2Cc3e6B6955E7993A5',
    amount: BigNumber.from('61948410256410300000000'),
  },
  {
    account: '0xa18669587490522d0e3c67464C8d4cad22405AFc',
    amount: BigNumber.from('58939179487179500000000'),
  },
  {
    account: '0x86282513581c5295Ab5157876E7687FC20deA071',
    amount: BigNumber.from('58482051304615400000000'),
  },
  {
    account: '0x36F22F65a3476F42f6Ae813DA097Dd471FcADEb1',
    amount: BigNumber.from('53801497435897400000000'),
  },
  {
    account: '0x2f45724d7E384b38D5C97206e78470544304887F',
    amount: BigNumber.from('53795302564102600000000'),
  },
  {
    account: '0x3ea4C7dc4aAbb87267073729FF4D1b529469931c',
    amount: BigNumber.from('53768492307692300000000'),
  },
  {
    account: '0x7e346f31a13D0a142885ff1A9494829947B48372',
    amount: BigNumber.from('52572225641025600000000'),
  },
  {
    account: '0x68057266b9e20A60C55D7b50Eb6f22117b1Eb842',
    amount: BigNumber.from('52150482051282100000000'),
  },
  {
    account: '0x8506970Ca968367E87c225C2F63C0A26F5AEad24',
    amount: BigNumber.from('51282051282051300000000'),
  },
  {
    account: '0xF5eC36a06475AeC69FA289053963FA6473802AB4',
    amount: BigNumber.from('51281179487179500000000'),
  },
  {
    account: '0xC02ad7b9a9121fc849196E844DC869D2250DF3A6',
    amount: BigNumber.from('50398861538461500000000'),
  },
  {
    account: '0x20EADfcaf91BD98674FF8fc341D148E1731576A4',
    amount: BigNumber.from('45606635897435900000000'),
  },
  {
    account: '0xDf7632EA06b068D7a249f465379D0d549290b1cd',
    amount: BigNumber.from('44402256410256400000000'),
  },
  {
    account: '0xf49d2bcC52F0b46a98204721f98Ce9d4e6730BEd',
    amount: BigNumber.from('44160410256410300000000'),
  },
  {
    account: '0x33eBB62DC9ddBf6B8F3C0efdF5BccC2e7AC60211',
    amount: BigNumber.from('40533435897435900000000'),
  },
  {
    account: '0x91cAaB3C0e9111043C97F5B3F10f614A193a11C9',
    amount: BigNumber.from('39292040176410300000000'),
  },
  {
    account: '0xD3802dcE7F7A54d59E7a64329d287624FF3F495a',
    amount: BigNumber.from('38625989743589700000000'),
  },
  {
    account: '0x1dA158559F54d81B13dda7b9602cB5E09468aC09',
    amount: BigNumber.from('38224225641025600000000'),
  },
  {
    account: '0x3dA9D70305B83Db1f545A5d50B19208b93cD0C21',
    amount: BigNumber.from('37102328205128200000000'),
  },
  {
    account: '0x23783f2d297555Fdcbd3CdA4b4cEe5af9DD2a02b',
    amount: BigNumber.from('30915794871794900000000'),
  },
  {
    account: '0xE3939654Deae5f54fD3e6B84b3A7F75f245062d8',
    amount: BigNumber.from('30854923076923100000000'),
  },
  {
    account: '0x000B79f52356189C80a9d3AdA3911D4438218516',
    amount: BigNumber.from('30473651282051300000000'),
  },
  {
    account: '0x70aD81d18F2838b8650D88740d8E337032c9BaAC',
    amount: BigNumber.from('28870038421538500000000'),
  },
  {
    account: '0x4e9C104d24cA8aA27c3e1A5d9D3249e96c5bbD80',
    amount: BigNumber.from('28770164102564100000000'),
  },
  {
    account: '0xFFfe1F5D42DC16AF7c05D0Aa24D2C649A869B367',
    amount: BigNumber.from('28731856410256400000000'),
  },
  {
    account: '0x678fb21b9736e6c7Da9f7d37a77Ab766bb2519c7',
    amount: BigNumber.from('26985897435897400000000'),
  },
  {
    account: '0x64B55f553a7648e8bCc1bD99136708d3F37917C5',
    amount: BigNumber.from('26623630769230800000000'),
  },
  {
    account: '0x2f5691bC4D8db66908BE10fad913fDc91c99Ce9F',
    amount: BigNumber.from('26588082051282100000000'),
  },
  {
    account: '0x06fB3FD7a77274aA9ac0d2b0Bc58A9AC9332D4ba',
    amount: BigNumber.from('26106071794871800000000'),
  },
  {
    account: '0x1793CD5916cC6f5b20593e001A1cC3B66268da1f',
    amount: BigNumber.from('24588666666666700000000'),
  },
  {
    account: '0xa33c7f924399b59A8Ee627388A108beAb5E12EaF',
    amount: BigNumber.from('21391117948717900000000'),
  },
  {
    account: '0x851Af2731E1Fb915E95f0b84d472FaF44BD3583b',
    amount: BigNumber.from('20512820512820500000000'),
  },
  {
    account: '0x76bbd639c87AaC623Aad1c3b648E6187A9392DEA',
    amount: BigNumber.from('19497723076923100000000'),
  },
  {
    account: '0x14B802407E24fEfFc77B75eaa45c1213e5C0E0D9',
    amount: BigNumber.from('18921671794871800000000'),
  },
  {
    account: '0x76cea8d9D3817FE361e1C1d32081F7c1dDB6aAae',
    amount: BigNumber.from('18697179487179500000000'),
  },
  {
    account: '0xbE79665B3Dcecfe1DD821f8714bc9bfc441ef92A',
    amount: BigNumber.from('18136020512820500000000'),
  },
  {
    account: '0x36837e2c2893b2d34fA80694B70eb53677aa6D4a',
    amount: BigNumber.from('16995364102564100000000'),
  },
  {
    account: '0xd35Dc42C3812acE3d313f8303114B731D428a0fa',
    amount: BigNumber.from('16902964102564100000000'),
  },
  {
    account: '0x563e8cB3055A3cc0502DC6D603F6dad21E1438Ea',
    amount: BigNumber.from('16631969230769200000000'),
  },
  {
    account: '0x69EF38D5A4ffb93579698b457622E8eB42CC4258',
    amount: BigNumber.from('16588533333333300000000'),
  },
  {
    account: '0xEDF7b675a2fE3c27efb263fb4c204A3f0fb17D46',
    amount: BigNumber.from('16265244182564100000000'),
  },
  {
    account: '0x89B8992AEc28D34eD8579fDe2b10B872DD26e617',
    amount: BigNumber.from('16103234280000000000000'),
  },
  {
    account: '0x1da75Fb0DA32653Fdab9DdecDb42F2ed61F8A28b',
    amount: BigNumber.from('15384615384615400000000'),
  },
  {
    account: '0x5FbD75846A90e965feFaCFE5D80e8e2bA675D841',
    amount: BigNumber.from('15384615384615400000000'),
  },
  {
    account: '0x5ef4Fd1D0f921550104E2a539eEed1f2092d54A1',
    amount: BigNumber.from('14799553696410300000000'),
  },
  {
    account: '0xBe289902A13Ae7bA22524cb366B3C3666c10F38F',
    amount: BigNumber.from('14346584615384600000000'),
  },
  {
    account: '0x2E15D7AA0650dE1009710FDd45C3468d75AE1392',
    amount: BigNumber.from('13339016136410300000000'),
  },
  {
    account: '0x5993Bad196C8786BaAEdB5A5868f338fE6ce4Cc2',
    amount: BigNumber.from('12737538461538500000000'),
  },
  {
    account: '0x2bEBa030cdC9c4a47c5aa657974840428b9fEfAc',
    amount: BigNumber.from('12021625905641000000000'),
  },
  {
    account: '0x6f9BB7e454f5B3eb2310343f0E99269dC2BB8A1d',
    amount: BigNumber.from('11486316714871800000000'),
  },
  {
    account: '0x9a49Fa38d835248225Bf5Eb18E7624430518A99D',
    amount: BigNumber.from('10964194871794900000000'),
  },
  {
    account: '0xfBdD5C349D1686d7B15B27f47217c55fE93D2bfc',
    amount: BigNumber.from('10887497435897400000000'),
  },
  {
    account: '0x9057e3B928E0b0b9cA2767a68538B3ADB290bc85',
    amount: BigNumber.from('10256410256410300000000'),
  },
  {
    account: '0x9b0c19000a8631c1f555bb365bDE308384E4f2Ff',
    amount: BigNumber.from('10256410256410300000000'),
  },
  {
    account: '0xD0C231A8DEC99bA56fC2F58C0785557FDAf4059E',
    amount: BigNumber.from('10256410256410300000000'),
  },
  {
    account: '0x7b6C0F34898878f2C9F0cA97D6E4494E15Ccb1C6',
    amount: BigNumber.from('10068625641025600000000'),
  },
  {
    account: '0xcE7aa2D3C1F8B572B50238230f5D55A78dB86087',
    amount: BigNumber.from('10050706258461500000000'),
  },
  {
    account: '0x13DbAd5d734Da7be69e6d91Aa6650df7D41DBbd1',
    amount: BigNumber.from('9547251282051280000000'),
  },
  {
    account: '0x268bc10A917438c7683823e195acD933aB43187a',
    amount: BigNumber.from('9465128409230770000000'),
  },
  {
    account: '0xb22E5Cadb0E487Aa335ab99818f5E1B5C0B96260',
    amount: BigNumber.from('9360143589743590000000'),
  },
  {
    account: '0xda248cC10b477C1144219183EC87b0621DAC37b3',
    amount: BigNumber.from('9218389743589750000000'),
  },
  {
    account: '0x1fb36B64649E6D55E100B31D8113cc0F7DD82592',
    amount: BigNumber.from('9069282051282050000000'),
  },
  {
    account: '0xFC5CC7832B2C0938Fe698D1bBd68D578A114bE09',
    amount: BigNumber.from('8648020512820510000000'),
  },
  {
    account: '0x2D7Baa2B939d6f7B38A1CB582B46Da2f71a42d1F',
    amount: BigNumber.from('11948717948717900000000'),
  },
  {
    account: '0x03f02D33cC02E006Cb25F7c7bFE3115EE6B55283',
    amount: BigNumber.from('8214738461538460000000'),
  },
  {
    account: '0x3150e3D0b3F1Dd76d753f67c28D053458d098053',
    amount: BigNumber.from('7867692307692310000000'),
  },
  {
    account: '0xEB85A4fFA6A194BCDE4Befd2eecAbd4F65C3F8C4',
    amount: BigNumber.from('7533907692307690000000'),
  },
  {
    account: '0x278BA1Da4e4ff2541234F19487fd94A12061CA55',
    amount: BigNumber.from('7494051282051280000000'),
  },
  {
    account: '0x9525603189Bc828B3af9de9454A79D9566E6e2fb',
    amount: BigNumber.from('13352812820512800000000'),
  },
  {
    account: '0xC102d21DA143Cb144bbdc4693553a850CF73cA5f',
    amount: BigNumber.from('7294902564102560000000'),
  },
  {
    account: '0x5f945C3682E1e0B95AD17d9a9836fF3f6C266EA9',
    amount: BigNumber.from('6666666666666670000000'),
  },
  {
    account: '0x00C67d9D6D3D13b42a87424E145826c467CcCd84',
    amount: BigNumber.from('6665805128205130000000'),
  },
  {
    account: '0xfc436651F2fD4885AD645035a63A7Cd22E6A868c',
    amount: BigNumber.from('6581948717948720000000'),
  },
  {
    account: '0xDd4a7cc4092515C130667C1bFd53Be0DE91062C5',
    amount: BigNumber.from('6154871794871790000000'),
  },
  {
    account: '0x9AbbEd91faC6e71977258Fa8aa949c9bD874F4DE',
    amount: BigNumber.from('6153847158974360000000'),
  },
  {
    account: '0x569d4C513673F8A611Cf4DDE30563498642a8579',
    amount: BigNumber.from('5465271794871800000000'),
  },
  {
    account: '0x8Be8247EF3A329b06cF3ce3D5B8AD3cA3Ed642C0',
    amount: BigNumber.from('5137715469743590000000'),
  },
  {
    account: '0x292b78a5AD6214971c0ec79Cb9d7eb3Cf20957Fb',
    amount: BigNumber.from('5128205128205130000000'),
  },
  {
    account: '0x9a568bFeB8CB19e4bAfcB57ee69498D57D9591cA',
    amount: BigNumber.from('4953589743589740000000'),
  },
  {
    account: '0xF7B10D603907658F690Da534E9b7dbC4dAB3E2D6',
    amount: BigNumber.from('4898553846153850000000'),
  },
  {
    account: '0x98D539aE90481E921fd9fb826500F2aF06337555',
    amount: BigNumber.from('4625169230769230000000'),
  },
  {
    account: '0x33d20F06b0021E9013F39D8F0dca1ff8BAe0A15c',
    amount: BigNumber.from('4569353846153850000000'),
  },
  {
    account: '0xdebC0D58526D6c0db42032B43e2341A4458D6594',
    amount: BigNumber.from('3897435897435900000000'),
  },
  {
    account: '0x883Ab2aE1BDDa0531078b27dd45600193aba1F34',
    amount: BigNumber.from('3779210256410260000000'),
  },
  {
    account: '0x8f9bE4310f9AbB0E5843Cc6363908C9B01dfeB3F',
    amount: BigNumber.from('3421958974358970000000'),
  },
  {
    account: '0x89E7d093d04d267BEd0639542823cc3286E2FAA7',
    amount: BigNumber.from('3333323076923080000000'),
  },
  {
    account: '0x9E7943cEAc1f02B00E5f9d6E182F257efaA4653e',
    amount: BigNumber.from('3174112820512820000000'),
  },
  {
    account: '0x0e41c9B548cf0545377AEEb693A6006172F1af81',
    amount: BigNumber.from('3084471794871800000000'),
  },
  {
    account: '0x2B2F2A9302Cdecdb7D4A2e7005336f7B345C1092',
    amount: BigNumber.from('2959169230769230000000'),
  },
  {
    account: '0x9b3f49A186670194f625199B822FCbDFD3Feacf7',
    amount: BigNumber.from('2943682051282050000000'),
  },
  {
    account: '0x62A32ea089109e7b8f0fE29d839736DDB0C753F6',
    amount: BigNumber.from('2778328205128210000000'),
  },
  {
    account: '0x237ec64cC27196F6a4C16AbdBb558B4C518400C2',
    amount: BigNumber.from('2746543589743590000000'),
  },
  {
    account: '0x14b889B25e70f60D8Dc0aa5F10c83680add61351',
    amount: BigNumber.from('2559487179487180000000'),
  },
  {
    account: '0xd16FDA96CB572DA89e4E39B04b99d99A8E3071fB',
    amount: BigNumber.from('2553466666666670000000'),
  },
  {
    account: '0x528Bad3C22874E8a9bb49689aa876F76f631e07d',
    amount: BigNumber.from('2318822430769230000000'),
  },
  {
    account: '0xA6B49397ce21bb62200e914F41BF371E5940Bb41',
    amount: BigNumber.from('2316092307692310000000'),
  },
  {
    account: '0xF0F32C3c8DEf7b43caA14fEd5752AbC5381C8374',
    amount: BigNumber.from('2285241025641030000000'),
  },
  {
    account: '0x605D50F68E737eBF7F6054D6f7860010FC80971F',
    amount: BigNumber.from('2007805128205130000000'),
  },
  {
    account: '0x82974862229A33eB52aF17AA28aF96a85D719E2c',
    amount: BigNumber.from('1977364102564100000000'),
  },
  {
    account: '0x0154d25120Ed20A516fE43991702e7463c5A6F6e',
    amount: BigNumber.from('1942184615384620000000'),
  },
  {
    account: '0xdAF6f97E24b4071c475Ff2A46B258C207Ffb5392',
    amount: BigNumber.from('1825641025641030000000'),
  },
  {
    account: '0xCa41730A221Aa83d2849Be36163DC301d0F053A8',
    amount: BigNumber.from('1690820512820510000000'),
  },
  {
    account: '0xb28037800F282E7A96a79fD0b0B5c1EED64bAaD2',
    amount: BigNumber.from('1499466666666670000000'),
  },
  {
    account: '0xD1a059Ae2eA4E6f4329dbd54a71A8ccF5d888d6B',
    amount: BigNumber.from('1342738461538460000000'),
  },
  {
    account: '0x7E4F1A12269C55d23c50e91017876D8A0B2ef14C',
    amount: BigNumber.from('1326410256410260000000'),
  },
  {
    account: '0x5BFA69517E17411bEDA54ea2d3672709F4867254',
    amount: BigNumber.from('1205015384615380000000'),
  },
  {
    account: '0x2FeD28677601cF6cb669A3cE424119bb1BA69eC0',
    amount: BigNumber.from('1056297435897440000000'),
  },
  {
    account: '0xd3B2a586180c9e306b38848D31e82F9E17D76F0C',
    amount: BigNumber.from('1044890150769230000000'),
  },
  {
    account: '0x156d27E5248eFe83Ccf74D934FC396e03F7685be',
    amount: BigNumber.from('5641025641025640000000'),
  },
  {
    account: '0x27e1317C497D423B6D7Ab98d006AFE5197D9591E',
    amount: BigNumber.from('942964102564103000000'),
  },
  {
    account: '0x7566fd09eD636e132BDaaF4Fc8Ddd5eF1FBc5c14',
    amount: BigNumber.from('941169230769231000000'),
  },
  {
    account: '0x9581F442075Eef408Bd5e560CCA77Fcf598f601e',
    amount: BigNumber.from('921784615384616000000'),
  },
  {
    account: '0xDF77257cA98DfAEF7d66FaF85Cf5a212849bAf25',
    amount: BigNumber.from('822861538461538000000'),
  },
  {
    account: '0xBD1f7d88C76A86C60d41bDDD4819fAe404e7151E',
    amount: BigNumber.from('822358974358974000000'),
  },
  {
    account: '0xbbe21151c726F9EEc42516524f58D0057261CC8a',
    amount: BigNumber.from('800106521025641000000'),
  },
  {
    account: '0xf695d9975Efd23d809d8857438c1aB6B3D09650f',
    amount: BigNumber.from('771815384615385000000'),
  },
  {
    account: '0x0206Bc8FC7C1e8635D14F73c0fdb035493F2FD84',
    amount: BigNumber.from('680564102564103000000'),
  },
  {
    account: '0x922e1ce088bB4Fc0295d992070B65088307957e2',
    amount: BigNumber.from('602482051282051000000'),
  },
  {
    account: '0x6ab791754298D6D6d7C182DC1572126B4eD24897',
    amount: BigNumber.from('553189743589744000000'),
  },
  {
    account: '0x18f768455E7f5fB09fC491fd86bcc282BcDD5973',
    amount: BigNumber.from('525651282051282000000'),
  },
  {
    account: '0xF71EB59210eed86E727d76f434A2694238213dEB',
    amount: BigNumber.from('520738461538462000000'),
  },
  {
    account: '0x8F844D3C0C06526387fA01d165Fba8C3984Efdac',
    amount: BigNumber.from('461538461538462000000'),
  },
  {
    account: '0x3195c3F94154364E897711e501e104f40D8e23fb',
    amount: BigNumber.from('416533333333333000000'),
  },
  {
    account: '0x3bd5e344Ac629C9f232F921bAfDeEEc312deAC9b',
    amount: BigNumber.from('376758974358974000000'),
  },
  {
    account: '0x3D16451A4B73e778BFEC126025bA79716a17E32d',
    amount: BigNumber.from('338358974358974000000'),
  },
  {
    account: '0xa8de8B84c4F4aab4BD90447872c48b6522dEF7DC',
    amount: BigNumber.from('198482051282051000000'),
  },
  {
    account: '0xaF34FeaC2Fb7449b745bC79046aD0CECd8bC159d',
    amount: BigNumber.from('193610256410256000000'),
  },
  {
    account: '0xe734F1270098fC0E3A978da32887ccf0339ba99a',
    amount: BigNumber.from('158461538461538000000'),
  },
  {
    account: '0xA178c15dd95553da5b79c1BA0bDE1659Fa2e76c8',
    amount: BigNumber.from('125538461538462000000'),
  },
  {
    account: '0x06DD6783C388b7B3080a8E0D3A3bFB8C07A6D1dF',
    amount: BigNumber.from('6502564102564100000'),
  },
  {
    account: '0xF6E2c94A609Ca303964b65EC991A1A0d2991B961',
    amount: BigNumber.from('10256410256410300000000'),
  },
  {
    account: '0x3dD48AD861F0B77D1312F9C95A13e52871Ca95e0',
    amount: BigNumber.from('30112574358974300000000'),
  },
  {
    account: '0x7cd7A5a66d3cd2F13559d7F8a052Fa6014e07d35',
    amount: BigNumber.from('59487764102564100000000'),
  },
]
